import { gql } from 'react-apollo';
import { full } from "../../../../graphql/fragments/dailyScripture";

export const getDailyScriptures = gql`
  query getDailyScriptures {
    dailyScriptures: daily_scriptures {
      ...allDailyScripturesFields
    }
  }

  ${full}
`;



// WEBPACK FOOTER //
// ./src/components/pages/dailyScriptures/queries/getDailyScriptures.js